import React from "react";
import { Box, MenuItem, Typography } from "@mui/material";
import Field from "../common/Field/Fi";
import Button from "../common/Button/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import useMediaQuery from "@mui/material/useMediaQuery";
import FilterListIcon from "@mui/icons-material/FilterList";
import sort from "../../assets/svgs/sort.svg";
import SearchField from "../common/SearchField/SearchField";
import YearSelect from "../common/YearSelect/YearSelect";
import MakeModel from "../common/CheckMarkSelect/MakeModel";

function ListingPageTopBar({
  toggleDrawerFilter,
  toggleDrawerSort,
  val,
  handleChange,
  resetFilters,
  setShowMoreFilterModal,
}) {
  const tabMatch = useMediaQuery("(max-width:900px)");
  const mobMatch = useMediaQuery("(max-width:600px)");
  
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        margin: { xs: "16px", sm: "16px 24px" },
        columnGap: { xs: "auto", md: "10px" },
        justifyContent: "center",
        marginTop: { xs: "0", md: "15px" },
        marginBottom: { xs: "16px", sm: "10px", md: "16px" },
      }}
    >
      {mobMatch ? (
        <>
          <SearchField label="Category, Make or Model" />
          <Box
            sx={{
              display: "flex",
              marginTop: "16px",
              marginBottom: "7px",
              justifyContent: "space-between",
            }}
          >
            <MobButtons
              onClick={toggleDrawerFilter(true)}
              text="Filters"
              icon={
                <FilterListIcon
                  sx={{
                    color: "#1F1F1F",
                    width: "15px",
                    height: "15px",
                    marginRight: "4px",
                  }}
                />
              }
            />
            <MobButtons
              onClick={toggleDrawerSort(true)}
              text="Sort by"
              icon={
                <img
                  src={sort}
                  alt="sort"
                  style={{ color: "#1F1F1F", marginRight: "4px" }}
                />
              }
            />
          </Box>
        </>
      ) : tabMatch ? (
        <>
          <Box sx={{ display: "flex", columnGap: "9px", marginBottom: "9px" }}>
            <SearchField
              label="Category, Make or Model"
              sx={{ width: "100%" }}
            />
            <Button
              variant="contained"
              bgColor="#F9D548"
              txColor="text.primary"
              size="lg"
              sx={{
                height: "46px !important",
                width: "128px",
                boxShadow: "none",
              }}
              hoverBg="#F3C04F"
            >
              Search
            </Button>
          </Box>
          <Box
            sx={{
              display: "flex",
              width: "83%",
              justifyContent: "space-between",
              margin: "0",
              padding: "0",
            }}
          >
            <Field
              height="38.14px"
              label=""
              value={val}
              handleChange={handleChange}
              sx={{ width: "18.3%" }}
              select={true}
            >
              <MenuItem key={0} value={"pro"}>
                Pro
              </MenuItem>
              <MenuItem key={1} value={"buy"}>
                Buy
              </MenuItem>
              <MenuItem key={2} value={"auction"}>
                Auction
              </MenuItem>
            </Field>
            <MakeModel
              height="467px"
              formStyle={{
                maxWidth: "282px",
                width: "100%",
              }}
              menuWidth="282px"
            />
            <YearSelect resetFilter={resetFilters} />
            <Box
              sx={{
                width: "17.6%",
                display: "flex",
                height: "38.14px",
                border: "1px solid #C7C7C7",
                borderRadius: "4px",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "9px 7px",
                "&:hover": {
                  cursor: "pointer",
                },
              }}
              onClick={() => setShowMoreFilterModal(true)}
            >
              <Typography
                variant="body1"
                color="#616161"
                fontWeight="400"
                fontSize="16px"
                lineHeight="24px"
              >
                More
              </Typography>
              <KeyboardArrowDownIcon sx={{ color: "#808080" }} />
            </Box>
          </Box>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            columnGap: "10px",
            width: "100%",
            justifyContent: { xs: "center", xl: "center" },
          }}
        >
          <SearchField
            label="Category, Make or Model"
            resetFilter={resetFilters}
          />
          <Field
            height="46.29px"
            label=""
            value={val}
            handleChange={handleChange}
            sx={{ width: "123px" }}
            select={true}
          >
            <MenuItem key={0} value={"pro"}>
              Pro
            </MenuItem>
            <MenuItem key={1} value={"buy"}>
              Buy
            </MenuItem>
            <MenuItem key={2} value={"auction"}>
              Auction
            </MenuItem>
          </Field>
          <MakeModel
            height="467px"
            formStyle={{ maxWidth: "282px", width: "100%" }}
            menuWidth="282px"
          />
          <YearSelect resetFilter={resetFilters} />
          <Box
            sx={{
              width: "123px",
              display: "flex",
              height: "46.29px",
              border: "1px solid #C7C7C7",
              borderRadius: "3px",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "11px 13px",
              "&:hover": {
                cursor: "pointer",
              },
            }}
            onClick={() => setShowMoreFilterModal(true)}
          >
            <Typography
              variant="body1"
              color="#616161"
              fontWeight="400"
              fontSize="16px"
              lineHeight="24px"
            >
              More
            </Typography>
            <KeyboardArrowDownIcon sx={{ color: "#808080" }} />
          </Box>
          <Button
            variant="contained"
            bgColor="#F9D548"
            txColor="text.primary"
            size="lg"
            sx={{
              height: "46px !important",
              width: "128px",
              boxShadow: "none",
            }}
            hoverBg="#F3C04F"
          >
            Search
          </Button>
        </Box>
      )}
    </Box>
  );
}

function MobButtons({ text, icon, onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        width: "47.7%",
        height: "36px",
        border: "1px solid #BFBFBF",
        borderRadius: "4px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        padding: "8px auto",
      }}
    >
      {icon}
      <Typography
        variant="body2"
        fontWeight="400"
        fontSize="14px"
        lineHeight="20px"
        color="text.primary"
      >
        {text}
      </Typography>
    </Box>
  );
}

export default ListingPageTopBar;
